import { request } from '../utils/request-utils';
import { listingRepresentativeURL } from './urls';

/**
 * Fetches the listing representative for a given houseId from portfolio-manager-api.
 * Returns null if no listing representative is found.
 * @param {string} houseId - The ID of the house.
 * @returns {Promise<{id: string, name: string, phoneNumber: string}|null>}
 */
export const fetchListingRepresentative = async (houseId) => {
  try {
    const response = await request(listingRepresentativeURL(houseId));

    if (!response || !response.id) {
      return null;
    }

    const { id, name, phoneNumber } = response;

    return {
      id,
      name,
      phoneNumber,
    };
  } catch (error) {
    // If 204 No Content or any error, return null
    return null;
  }
};
